import React from 'react';
import AdminDynamicTable from '../components/common/Tables/AdminDynamicTable';

export const DeviceTypes = ({
  client
 }) => {
    return (
        <div className="device_types">
            <AdminDynamicTable
                client={client}
                url="device_types"
                title="Device Types"
                excludeHeaderFields={['id', 'created_date', 'updated_date']}
                excludeEditFields={['id', 'created_date', 'updated_date']}
            />
        </div>
    );
}

export default DeviceTypes;


// WEBPACK FOOTER //
// ./src/pages/DeviceTypes.jsx